import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HIDE_ON = ["/contact", "/enquiries"];

const MobileCTA = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 360);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (HIDE_ON.includes(pathname)) return null;

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 px-margin-mobile pt-6 pb-[calc(env(safe-area-inset-bottom,0px)+14px)] bg-gradient-to-t from-background-ivory via-background-ivory/95 to-transparent transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-none"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      data-testid="mobile-sticky-cta"
    >
      <Link
        to="/contact"
        className={`flex items-center justify-center gap-3 w-full bg-brand-ink text-ink-on-dark py-4 shadow-[0_8px_30px_rgba(40,36,31,0.25)] active:scale-[0.99] transition-transform duration-200 ${
          visible ? "pointer-events-auto" : "pointer-events-none"
        }`}
        tabIndex={visible ? 0 : -1}
        aria-hidden={!visible}
        data-testid="mobile-sticky-cta-button"
      >
        <span className="font-inter text-label-sm uppercase tracking-widest">
          Begin a Conversation
        </span>
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};

export default MobileCTA;
